import { render, staticRenderFns } from "./BuySubscriptionFactor.vue?vue&type=template&id=6871c258"
import script from "./BuySubscriptionFactor.vue?vue&type=script&lang=js"
export * from "./BuySubscriptionFactor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports